function ReferralToClinicVO(id, visitCardId, benefitDescription, treatmentInSpecializedFacility,
                     specializedFacilityId, hospitalReferral, diagnosisTips, pharmacyTips, otherTips,
                     creationDate, alreadyPrinted) {
    this.id = id;
    this.visitCardId = visitCardId;
    this.benefitDescription = benefitDescription;
    this.treatmentInSpecializedFacility = treatmentInSpecializedFacility;
    this.specializedFacilityId = specializedFacilityId;
    this.hospitalReferral = hospitalReferral;
    this.diagnosisTips = diagnosisTips;
    this.pharmacyTips = pharmacyTips;
    this.otherTips = otherTips;


    this.creationDate = creationDate;
    this.alreadyPrinted = alreadyPrinted;

    var _typeContext = {
        creationDate: Date
    };

    this._getType = function (property) {
        if (_typeContext.hasOwnProperty(property)) {
            return _typeContext[property];
        }
        else {
            return undefined;
        }
    };

    var _mappingContext = {
    };

    this._getMapping = function (property) {
        if (_mappingContext[property]) {
            return _mappingContext[property];
        }
        else {
            return undefined;
        }
    };
}
